import ivclass from '@invideoio/web-shared/Modules/IVClass';

import SearchBox from '@components/search-box';
const SearchPageHeader = () => {
  return (
    <section
      className={ivclass(
        'iv-mt-[87px] md:iv-mt-[73px] sm:iv-mt-[43px]',
        'iv-mb-100 lg:iv-mb-100 md:iv-mb-50 sm:iv-mb-30',
      )}
    >
      <div className={ivclass('iv-container iv-mx-auto')}>
        <div className={ivclass('iv-grid iv-grid-cols-12')}>
          <div
            className={ivclass(
              'iv-col-start-2 lg:iv-col-start-1',
              'iv-col-span-7 lg:iv-col-span-9 md:iv-col-span-11 sm:iv-col-span-12',
              'sm:iv-text-center',
            )}
          >
            <h1
              className={ivclass(
                'iv-text-heading-4xl md:iv-text-heading-3xl sm:iv-text-heading-m',
                'iv-font-extrabold',
                'iv-px-20 lg:iv-px-[105px] md:iv-px-[55px]',
                'iv-mb-60 md:iv-mb-30 sm:iv-mb-20',
              )}
            >
              Blog search
            </h1>
            <div
              className={ivclass('iv-px-20 lg:iv-px-[110px] md:iv-px-[55px]')}
            >
              <SearchBox placeholder="Try “social media tips”" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SearchPageHeader;
